// Components==============
import { useMutation, useQueryClient } from "@tanstack/react-query";
import axios from "axios";
// =========================

type RequestType = Partial<UserEntity>;

const storeTop3Themes = (data: RequestType) =>
  axios.post("/api/top3-themes", data).then((r) => r.data);

export default function useStoreTop3Themes() {
  const queryClient = useQueryClient();

  const mutation = useMutation({
    mutationFn: storeTop3Themes,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["user"] });
    },
    onError: (error) => {
      console.error("Error storing top 3 themes:", error);
    },
  });

  return mutation;
}
